<template>
  <span class="mit-key-notes">
    <v-tooltip top max-width="400" color="#333" offset-overflow style="opacity: 1!important;">
      <template v-slot:activator="{ on }">
        <v-icon :color="(search.text.length > 0 && notes.indexOf(search.text) > -1 )?'primary':''" :class="" v-on="on">mdi-text-box-outline</v-icon>
      </template>
      <span>{{notes}}</span>
    </v-tooltip>
  </span>
</template>

<script>

export default {
  name: 'MitKeyNotes',
  props: {
    notes:String,
    search:{
      default: {
        text:''
      },
      type: Object
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
